export default __webpack_public_path__ + "static/media/netflix-logo-removebg-preview.427944a1.png";